import { faPen, faTrash, faQuestionCircle, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../Auth/AuthContext'
import { Table, Button,Row,Col,Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext';
import { TablePagination, Loading } from '../Library';
import { listVisitorReport } from '../Network/Visitor';
import { AlertModalContext } from '../Library/AlertModalContext'
import { NotifyContext } from '../Library/Notify'
import "./VisitorSecurity.css"
import axios from 'axios'
import { wtc5214,visitor8082 } from '../Network/Config'
import DatePicker from "react-datepicker";

function VisitorSecurity(props) {
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const notifyCx = useContext(NotifyContext);
    const lang = langCx.lang.visitor
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false)
    const [visitorReportList, setVisitorReportList] = useState([])
    const [companyName, setCompanyName] = useState("")
    const [page, setPage] = useState(1)
    const size = 10
    const [count, setCount] = useState(0)
    const [securityVisitor, setSecurityVisitor] = useState([])
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null) 
    

    useEffect( async ()=>{
        try {
            setIsLoading(true)
            const formData = new FormData();
            formData.append('company_name', props.company);
            if(startDate == null || endDate == null){
                formData.append('start_date', dayjs().format("YYYY-MM-DD"));
                formData.append('end_date', dayjs().add(1,'day').format("YYYY-MM-DD"));
            }else{
                formData.append('start_date', dayjs(startDate).format("YYYY-MM-DD"));
                formData.append('end_date', dayjs(endDate).format("YYYY-MM-DD"));
            }
            const responseData = await axios.post(visitor8082+'/visitor/api/v1/security_list', formData);
            setSecurityVisitor(responseData.data);
            setIsLoading(false)
        } catch (e) {
            console.error(e);
            setIsLoading(false)
        }
    }, [10, props,startDate,endDate])

        

    const formattedDate = (date) => {
        const dateFormatted = dayjs(date).format("D MMM YYYY - H:mm")
        return dateFormatted
    }

    const deleteSecureFromList =  (id, name)  =>{
        alertModal.setTitle(lang.delete_visitor_security)
        alertModal.setDescription(lang.sure_to_delete)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: async () =>{ 
                    alertModal.setIsShow(false)
                    setIsLoading(true)
                    const formData = new FormData();
                    formData.append('security_id', id);
                    formData.append('company_name', props.company);
                    await axios.post(visitor8082+'/visitor/api/v1/security_delate', formData);
                    history.go(0)
                    setIsLoading(false)
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        
        alertModal.setIsShow(true)
    }

    const VisitorVisitorItem = ({ id, name, onEditClick, onDeleteClick }) => {
        return(
            <tr>
                <td></td>
                <td>{id}</td>
                <td>{name}</td>
                <td>
                    <div className="action-container">
                        <Button size="sm"
                        onClick={onEditClick}>
                            <FontAwesomeIcon icon={faPen}/>
                        </Button>
                        <Button size="sm" variant="danger" style={{marginLeft: 10}}
                        onClick={onDeleteClick}>
                            <FontAwesomeIcon icon={faTrash}/>
                        </Button> 
                    </div>
                </td>
            </tr>
        )
    }

    return(
        <div id="visitor-report">
            { isLoading ? <Loading/> : null }
            <div className="button-container">
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <div>{lang.visitor_security_guard}</div>
                    <div style={{justifyContent:'flex-end'}}>
                        <Button onClick={()=>history.push("/visitor_security/create")}>เพิ่มช่าง</Button>
                    </div>
                </div>
            </div>
            <div>
            <Row>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่เริ่มต้น'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={startDate}
                                onChange={(date)=>{
                                    setStartDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่เริ่มต้น'}
                                maxDate={new Date()}
                                />
                                </div>
                            </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่สิ้นสุด'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={endDate}
                                onChange={(date)=>{
                                    setEndDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่สิ้นสุด'}
                                maxDate={new Date()}
                                minDate={startDate}
                                />
                                </div>
                            </Form.Group>
                </Col>
            </Row>
            </div>
            
            <div className='table-container'>
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{'ID'}</th>
                            <th>{'ชื่อ-นามสกุล'}</th>
                            <th>{'แก้ไข'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { securityVisitor.map((item, key) =>
                        <VisitorVisitorItem
                        key={key}
                        id={item.security_id}
                        name={item.security_name}
                        onEditClick={()=>history.push("/visitor_security/edit/"+item.security_id)}
                        onDeleteClick={()=>deleteSecureFromList(item.security_id, item.security_name)}
                        />
                        )}
                    </tbody>
                </Table>
            </div>
            <TablePagination
            dataLength={Math.ceil(count / size)}
            currentPage={page}
            size={size}
            handlerPaginationClick={(page)=>setPage(page)}
            prevClick={()=>setPage(page - 1)}
            nextClick={()=>setPage(page + 1)}
            firstPageClick={(page)=>setPage(page)}
            lastPageClick={(page)=>setPage(page)}
            disabledPrev={page === 1}
            disabledNext={page === Math.ceil(count / size)}
            />
        </div>
    )
}

export default VisitorSecurity;
